module.exports = __webpack_public_path__ + "static/img/upArrow.f0aa0566.png";